<!-- Modifier mes infos (P4.1) : la photo, le nom et le niveau, sur les champs de
     l'app. La langue a sa propre feuille (P4.2) : elle n'est plus en double ici. -->
<vw-toast-popup [isOpen]="isOpen" [title]="'profile.edit-account.title' | translate" (close)="onClose()">
  <form class="flex flex-col gap-6 px-4 pb-6" novalidate (ngSubmit)="submit()">
    <!-- La photo : un avatar rond, comme sur Mon compte, et un lien pour la changer. -->
    <div class="flex items-center gap-4">
      @if (pictureUrl) {
        <img [src]="pictureUrl" alt="" data-testid="edit-user-avatar"
          class="h-24 w-24 shrink-0 rounded-pill bg-vw-surface-tint object-cover">
      } @else {
        <span data-testid="edit-user-avatar"
          class="flex h-24 w-24 shrink-0 items-center justify-center rounded-pill bg-vw-surface-tint font-display text-display text-vw-primary-ink"
          aria-hidden="true">
          @if (initial) {
            {{ initial }}
          } @else {
            <vw-circle-user-icon class="block h-12 w-12" />
          }
        </span>
      }
      <div class="flex min-w-0 flex-col items-start">
        <button type="button" data-testid="edit-user-picture"
          class="flex min-h-target items-center gap-2 text-body font-semibold text-vw-primary underline disabled:no-underline"
          [disabled]="uploading" (click)="fileInput.click()">
          @if (uploading) {
            <vw-loading-icon class="block h-5 w-5" />
            {{ 'profile.edit-account.picture.uploading' | translate }}
          } @else {
            {{ (pictureUrl ? 'profile.edit-account.picture.change' : 'profile.edit-account.picture.add') | translate }}
          }
        </button>
        @if (pictureFailed) {
          <p role="alert" class="text-body-s text-vw-danger" data-testid="edit-user-picture-error">
            {{ 'profile.edit-account.picture.error' | translate }}
          </p>
        }
      </div>
      <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)">
    </div>

    <div class="flex flex-col gap-2">
      <label for="edit-user-pseudo" class="text-body-s font-semibold text-vw-body">
        {{ 'profile.edit-account.pseudo.label' | translate }}
      </label>
      <vw-text-input inputId="edit-user-pseudo" data-testid="edit-user-pseudo" autocomplete="nickname"
        [placeholder]="'profile.edit-account.pseudo.placeholder'" [isError]="!!pseudoErrorKey"
        [(ngModel)]="pseudo" name="pseudo" (valueChange)="pseudoErrorKey = null"></vw-text-input>
      @if (pseudoErrorKey) {
        <p role="alert" class="text-body-s text-vw-danger" data-testid="edit-user-pseudo-error">
          {{ pseudoErrorKey | translate: { max: pseudoMaxLength } }}
        </p>
      }
    </div>

    <div class="flex flex-col gap-2">
      <p id="edit-user-expertise" class="text-body-s font-semibold text-vw-body">
        {{ 'profile.edit-account.expertise.label' | translate }}
      </p>
      <vw-choice-selector variant="segmented" data-testid="edit-user-expertise" [options]="expertiseOptions"
        [(value)]="expertise" [ariaLabel]="'profile.edit-account.expertise.label' | translate"></vw-choice-selector>
    </div>

    <!-- Refus du serveur : juste au-dessus du bouton, la feuille reste ouverte. -->
    <div class="flex flex-col gap-3">
      @if (saveFailed) {
        <p role="alert" class="text-body-s text-vw-danger" data-testid="edit-user-error">
          {{ 'errors.businessException' | translate }}
        </p>
      }
      <!-- Jamais grisé : un envoi incomplet dit ce qui manque. -->
      <vw-button type="submit" look="primary" customClass="w-full" data-testid="edit-user-save"
        [label]="'profile.edit-account.save' | translate" [loading]="saving"></vw-button>
    </div>
  </form>
</vw-toast-popup>
